import type { SVGProps } from 'react';
const SvgOutlinedFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#outlined_flag_svg__a)">
      <path
        fill="currentColor"
        d="m14 6-1-2H5v17h2v-7h5l1 2h7V6h-6Zm4 8h-4l-1-2H7V6h5l1 2h5v6Z"
      />
    </g>
    <defs>
      <clipPath id="outlined_flag_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOutlinedFlag;
